// Detect if we're running on localhost (CRA dev) vs deployed
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

// In dev: CRA proxy handles /api, so base is "".
// In prod: same origin (nginx proxies /api/* to backend).
export const HTTP_BASE = isLocalhost ? "" : window.location.origin;

// API base for fetch calls (set REACT_APP_API_URL in production)
export const API_BASE = process.env.REACT_APP_API_URL || "";
